import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 5.1.png";
import imageTwo from "../../../assets/lesson 5.2.png";

function LessonFive() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>5.1</span> Look at the pictures and write the questions.
          </h4>
          <p className="table row">
            <img src={imageOne} />
            <ol className="">
              <li>
                (you / watch / it?)
                <input
                  className="border"
                  value="Are you watching it?"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />{" "}
                No, you can turn it off.
              </li>
              <li>
                (you / go / now?)
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background:
                      q1.trim() === "Are you going now?" ? "#198754" : "white",
                    color:
                      q1.trim() === "Are you going now?" ? "white" : "black",
                  }}
                />
                Yes, see tomorrow.
              </li>
              <li>
                (it / rain?)
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "Is it raining?" ? "#198754" : "white",
                    color: q2.trim() === "Is it raining?" ? "white" : "black",
                  }}
                />
                No, not at the moment.
              </li>
              <li>
                (you / enjoy / the film?)
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "Are you enjoying the film?"
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "Are you enjoying the film?"
                        ? "white"
                        : "black",
                  }}
                />
                Yes, it's very funny.
              </li>
              <li>
                (that clock / work?)
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "Is that clock working?"
                        ? "#198754"
                        : "white",
                    color:
                      q4.trim() === "Is that clock working?"
                        ? "white"
                        : "black",
                  }}
                />
                No, it's broken.
              </li>
              <li>
                {" "}
                (you / wait / for a bus?)
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "Are you waiting for a bus?"
                        ? "#198754"
                        : q5.trim() === "She's sitting"
                        ? "#198754"
                        : "white",
                    color:
                      q5.trim() === "Are you waiting for a bus?"
                        ? "white"
                        : q5.trim() === "She's sitting"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                No, for a taxi.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>5.2</span> Look at the picturs and complete the questions.
            Use:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>cry</li>
              <li>eat</li>
              <li>go</li>
              <li>laugh</li>
              <li>look at</li>
              <li className="strike">read</li>
            </ul>
            <img src={imageTwo} />
            <ol className="">
              <li>
                What
                <input
                  className="border"
                  value="are you reading"
                  disabled
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                Where
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "is"
                        ? "#198754"
                        : q7.trim() === "'s"
                        ? "#198754"
                        : "white",
                    color:
                      q7.trim() === "is"
                        ? "white"
                        : q7.trim() === "'s"
                        ? "white"
                        : "black",
                  }}
                />
                she
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "going"
                        ? "#198754"
                        : q8.trim() === "'s"
                        ? "#198754"
                        : "white",
                    color:
                      q8.trim() === "going"
                        ? "white"
                        : q8.trim() === "'s"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                What
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "are you eating" ? "#198754" : "white",
                    color: q9.trim() === "are you eating" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                Why
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "are you crying" ? "#198754" : "white",
                    color: q9.trim() === "are you crying" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                What
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "are they looking at"
                        ? "#198754"
                        : "white",
                    color:
                      q10.trim() === "are they looking at" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                Why
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "is he laughing"
                        ? "#198754"
                        : q11.trim() === "'s having"
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "is he laughing"
                        ? "white"
                        : q11.trim() === "'s he laughing"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>5.3</span> Make questions from these words. Put the words in
            the right order.
          </h4>
          <p className="table row">
            <ol>
              <li>
                (is / working / Ben / today)
                <input
                  className="border"
                  value="Is Ben working today"
                  disabled
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                (what / the children / are / doing)
                <input
                  className="border"
                  value="What are the children doing"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                (you / are / listening / to me)
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background:
                      q14.trim() === "are you listening to me"
                        ? "#198754"
                        : "white",
                    color:
                      q14.trim() === "are you listening to me"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (Where / your friends / are / going)
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background:
                      q15.trim() === "Where are your friends going?"
                        ? "#198754"
                        : "white",
                    color:
                      q15.trim() === "Where are your friends going?"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (are / watching / your parents / TV)
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background:
                      q16.trim() === "Are your parents watching TV"
                        ? "#198754"
                        : "white",
                    color:
                      q16.trim() === "Are your parents watching TV"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (what / Jessica / is / cooking)
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background:
                      q17.trim() === "What is Jessica cooking"
                        ? "#198754"
                        : q17.trim() === "What's Jessica cooking."
                        ? "#198754"
                        : "white",
                    color:
                      q17.trim() === "What is Jessica cooking"
                        ? "white"
                        : q17.trim() === "What's Jessica cooking."
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (why / you / are / looking / at me)
                <input
                  className="border"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background:
                      q18.trim() === "Why are you looking at me"
                        ? "#198754"
                        : "white",
                    color:
                      q18.trim() === "Why are you looking at me"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (is / coming / the bus)
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background:
                      q19.trim() === "Is the bus comming" ? "#198754" : "white",
                    color:
                      q19.trim() === "Is the bus comming" ? "white" : "black",
                  }}
                />
                ?
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>5.4</span> Write short answers{" "}
            <span>
              <strong>Yes, I am. / No, he isn't.</strong>etc.
            </span>
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                Are you watching TV?
                <input
                  className="border"
                  value="No, I'm not"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Are you wearing a watch?
                <input
                  className="border"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background:
                      q20.trim() === "Yes, I am."
                        ? "#198754"
                        : q20.trim() === "No, I'm not."
                        ? "#198754"
                        : "white",
                    color:
                      q20.trim() === "Yes, I am."
                        ? "white"
                        : q20.trim() === "No, I'm not."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Are you eating something?
                <input
                  className="border"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background:
                      q21.trim() === "Yes, I am."
                        ? "#198754"
                        : q21.trim() === "No, I'm not."
                        ? "#198754"
                        : "white",
                    color:
                      q21.trim() === "Yes, I am."
                        ? "white"
                        : q21.trim() === "No, I'm not."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Is it raining?
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  style={{
                    background:
                      q22.trim() === "Yes, it is."
                        ? "#198754"
                        : q22.trim() === "No, it's not."
                        ? "#198754"
                        : q22.trim() === "No, it isn't."
                        ? "#198754"
                        : "white",
                    color:
                      q22.trim() === "Yes, it is."
                        ? "white"
                        : q22.trim() === "No, it's not."
                        ? "white"
                        : q22.trim() === "No, it isn't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Are you sitting on the floor?
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "Yes, I am."
                        ? "#198754"
                        : q23.trim() === "No, I'm not."
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "Yes, I am."
                        ? "white"
                        : q23.trim() === "No, I'm not."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Are you feeling well?
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background:
                      q24.trim() === "Yes, I am."
                        ? "#198754"
                        : q24.trim() === "No, I'm not."
                        ? "#198754"
                        : q24.trim() === "I am not learning English."
                        ? "#198754"
                        : q24.trim() === "I'm not learning English."
                        ? "#198754"
                        : "white",
                    color:
                      q24.trim() === "Yes, I am."
                        ? "white"
                        : q24.trim() === "No, I'm not."
                        ? "white"
                        : q24.trim() === "I am not learning English."
                        ? "white"
                        : q24.trim() === "I'm not learning English."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        {/* <hr /> */}
      </div>
    </>
  );
}

export default LessonFive;
